
/**
 * Grammar and Dependency Rules for MA command line
 */
export const GRAMMAR_RULES = {
    MA2: {
        // Definitions of what's allowed after certain keywords
        dependencies: {
            "Assign": {
                allowedNext: ["Sequence", "Cue", "Macro", "Plugin", "Layout", "Group"],
                contexts: {
                    "Sequence": { allowedNext: ["Number"], followUp: ["At"] },
                    "At": { allowedNext: ["Executor"] }
                }
            },
            "Store": {
                allowedNext: ["Cue", "Group", "Preset", "Sequence", "Page"],
                followUp: ["/merge", "/overwrite", "/create", "/remove"]
            },
            "Go": {
                allowedNext: ["Executor", "Cue"]
            }
        },
        // Mapping of placeholders to actual common objects
        placeholders: {
            "Object": ["Cue", "Group", "Preset", "Sequence", "Fixture", "Channel", "Macro", "Page"],
            "Executor": ["Executor", "Exec"],
            "Value": ["0", "100", "Full", "Zero"]
        }
    },
    MA3: {
        dependencies: {
            "Assign": {
                allowedNext: ["Sequence", "Cue", "Macro", "Plugin", "Layout", "Group", "DataPool"],
                contexts: {
                    "Sequence": { allowedNext: ["Number"], followUp: ["At"] },
                    "At": { allowedNext: ["Executor"] }
                }
            },
            "Store": {
                allowedNext: ["Cue", "Group", "Preset", "Sequence", "Page"],
                followUp: ["/merge", "/overwrite", "/create", "/remove"]
            },
            "Go+": {
                allowedNext: ["Sequence", "Cue", "Executor"]
            }
        },
        placeholders: {
            "Object": ["Cue", "Group", "Preset", "Sequence", "Fixture", "Channel", "Macro", "Page", "DataPool"],
            "Executor": ["Executor"],
            "Value": ["0", "100", "Full", "Zero"]
        }
    }
};
